import React from 'react';

const getUnitByProperty = (list, propertyName) => {
  const item = list.find(p => p.property_name === propertyName);
  return item ? item.unit : "";
};

const getSpecificationByProperty = (list, propertyName) => {
  const item = list.find(p => p.property_name === propertyName);
  return item ? item.specification : "";
};

const QCReportView = React.forwardRef(({ data, qcpropertylist }, ref) => (
  <div ref={ref} style={{ padding: '0 10pt 10pt 10pt', fontFamily: 'Arial', color: 'black', backgroundColor: 'white' }}>

    {/* Logo and Header */}
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <img src="/Assets/images/ITC_logo.png" alt="Logo" style={{ width: '100px', height: 'auto' }} />

      <div style={{ textAlign: 'center', flexGrow: 1, paddingRight: '30px' }}>
        <h1 style={{ fontSize: '18pt', margin: 0 }}>ITC Limited-PSPD</h1>
        <h2 style={{ fontSize: '12pt', margin: 0 }}>Website: www.itcpspd.com</h2>
      </div>

    </div>

    {/* Consignee and Dealer Information */}
    <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
      <div style={{ width: '65%' }}>

        <p><strong style={{ marginRight: '38px' }}>Dealer Name :</strong> {data.consigneename}</p>
        <p><strong style={{ marginRight: '10px' }}>Consignee Name :</strong> {data.dealername}</p>
        <p><strong style={{ marginRight: '74px' }}>Quality :</strong> {data.itemcode}</p>
        <p><strong style={{ marginRight: '89px' }}>GSM :</strong> {data.gsm}</p>
        <p><strong style={{ marginRight: '92px' }}>Size :</strong> {data.size} (cm)</p>
      </div>



      <div style={{ width: '35%' }}>
        <p><strong>Invoice No :</strong> {data.invoiceno}</p>
        <p>
          <strong>Customer Order No :</strong> {data.transferorderno || data.indentno}
        </p>

      </div>
    </div>


    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: "15px" }}>
      <thead>
        <tr>
          <th style={{ border: '1px solid black', padding: '4px', borderBottom: 'none' , borderRight: 'none'}}>S.No</th>
          <th style={{ border: '1px solid black', padding: '4px', borderBottom: 'none', borderRight: 'none' }}>Properties</th>
          <th style={{ border: '1px solid black', padding: '4px', borderBottom: 'none', borderRight: 'none' }}>Unit</th>
          <th
            style={{ border: '1px solid black', borderRight: 'none', padding: '4px', textAlign: 'center', borderBottom: 'none' }}
            colSpan={2}
          >
            Specification
          </th>
          <th style={{ border: '1px solid black', borderBottom: 'none', padding: '4px', }}>Values</th>
        </tr>
      </thead>


      <tbody>
        {/* Repeat the below tr for each row of the table */}
        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none', borderRight: 'none' }}>1</td>
          <td style={{ border: '1px solid black', padding: '4px', borderRight: 'none', borderBottom: 'none' }}>Substance</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}> {getUnitByProperty(qcpropertylist, "Substance")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}>{data.spec_avggsm} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Substance")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none' }}>{data.avggsm}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none', borderRight: 'none' }}>2</td>
          <td style={{ border: '1px solid black', padding: '4px', borderRight: 'none', borderBottom: 'none' }}>Caliper</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}> {getUnitByProperty(qcpropertylist, "Caliper")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}>{data.spec_caliper} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Caliper")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',  borderBottom: 'none' }}>{data.caliper}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none', borderRight: 'none' }}>3</td>
          <td style={{ border: '1px solid black', padding: '4px', borderRight: 'none', borderBottom: 'none' }}>Bulk</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}>{getUnitByProperty(qcpropertylist, "Bulk")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}>{data.spec_bulkccpergm} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none', borderBottom: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Bulk")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',  borderBottom: 'none' }}>{data.bulkccpergm}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none' , borderRight: 'none'}} rowSpan="4">4</td>
          <td style={{ border: '1px solid black', padding: '4px', borderBottom: 'none', borderRight: 'none' }}>Stiffness (MD)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none',borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Stiffness (MD)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none',borderRight: 'none' }}>{data.spec_stiffnessmd} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none',borderRight: 'none'  }}>{getSpecificationByProperty(qcpropertylist, "Stiffness (MD)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none', }}>{data.stiffnessmd}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', borderBottom: 'none', borderRight: 'none' }}>Stiffness (CD)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Stiffness (CD)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none', borderRight: 'none' }}>{data.spec_stiffnesscd} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Stiffness (CD)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderBottom: 'none', }}>{data.stiffnesscd}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px',borderBottom: 'none', borderRight: 'none' }}>Stiffness (GM)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Stiffness (GM)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_stiffnessgm} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Stiffness (GM)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none' }}>{data.stiffnessgm}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px',borderBottom: 'none', borderRight: 'none' }}>Stiffness ratio</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Stiffness ratio")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_ratio}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Stiffness ratio")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none',  }}>{data.ratio}</td>
        </tr>


        {/* <tr>
          <td style={{ borderLeft: "1px solid black", padding: '4px', textAlign: 'center' }}></td>
          <td style={{ border: '1px solid black', padding: '4px' }}>Stiffness (MD)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getUnitByProperty(qcpropertylist, "Stiffness (MD)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.spec_stiffnessmd} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getSpecificationByProperty(qcpropertylist, "Stiffness (MD)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.stiffnessmd}</td>
        </tr>

        <tr>
          <td style={{ borderLeft: '1px solid black', padding: '4px', textAlign: 'center' }}>4</td>
          <td style={{ border: '1px solid black', padding: '4px' }}>Stiffness (CD)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getUnitByProperty(qcpropertylist, "Stiffness (CD)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.spec_stiffnesscd} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getSpecificationByProperty(qcpropertylist, "Stiffness (CD)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.stiffnesscd}</td>
        </tr>

        <tr>
          <td style={{ borderLeft: '1px solid black', padding: '4px', textAlign: 'center' }}></td>
          <td style={{ border: '1px solid black', padding: '4px' }}>Stiffness (GM)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getUnitByProperty(qcpropertylist, "Stiffness (GM)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.spec_stiffnessgm} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getSpecificationByProperty(qcpropertylist, "Stiffness (GM)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.stiffnessgm}</td>
        </tr>

        <tr>
          <td style={{ borderLeft: '1px solid black', padding: '4px', textAlign: 'center' }}></td>
          <td style={{ border: '1px solid black', padding: '4px' }}>Stiffness ratio</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getUnitByProperty(qcpropertylist, "Stiffness ratio")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.spec_ratio}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getSpecificationByProperty(qcpropertylist, "Stiffness ratio")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.ratio}</td>
        </tr> */}

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>5</td>
          <td style={{ border: '1px solid black', padding: '4px' ,borderBottom: 'none', borderRight: 'none'}}>Ply Bond</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' ,borderBottom: 'none', borderRight: 'none'}}>{getUnitByProperty(qcpropertylist, "Ply Bond")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_plybond}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Ply Bond")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none',  }}>{data.plybond}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none' }}>6</td>
          <td style={{ border: '1px solid black', padding: '4px',borderBottom: 'none', borderRight: 'none' }}>Roughness PPS (T/S)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Roughness PPS (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_roughnesspps}  </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Roughness PPS (T/S)")} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none',  }}>{data.roughnesspps}</td>
        </tr>

        <tr>
          <td style={{ borderLeft: '1px solid black', padding: '4px', textAlign: 'center' }} rowSpan="2">7</td>
          <td style={{ border: '1px solid black', padding: '4px',borderBottom: 'none', borderRight: 'none' }}>Cobb 60 (T/S)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Cobb 60 (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_cobbtop} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Cobb 60 (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' ,borderBottom: 'none', }}>{data.cobbtop}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px' ,borderBottom: 'none', borderRight: 'none'}}>Cobb 60 (B/S)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Cobb 60 (B/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_cobbback} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Cobb 60 (B/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none',  }}>{data.cobbback}</td>
        </tr>


        {/* <tr>
          <td style={{ borderLeft: '1px solid black', padding: '4px', textAlign: 'center' }}>7</td>
          <td style={{ border: '1px solid black', padding: '4px' }}>Cobb 60 (T/S)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getUnitByProperty(qcpropertylist, "Cobb 60 (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.spec_cobbtop}  </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getSpecificationByProperty(qcpropertylist, "Cobb 60 (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.cobbtop}</td>
        </tr>

        <tr>
          <td style={{ borderLeft: '1px solid black', padding: '4px', textAlign: 'center' }}></td>
          <td style={{ border: '1px solid black', padding: '4px' }}>Cobb 60 (B/S)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getUnitByProperty(qcpropertylist, "Cobb 60 (B/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.spec_cobbback} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getSpecificationByProperty(qcpropertylist, "Cobb 60 (B/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{data.cobbback}</td>
        </tr> */}

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none' , borderRight: 'none'}}>8</td>
          <td style={{ border: '1px solid black', padding: '4px' ,borderBottom: 'none', borderRight: 'none'}}>IGT Dry pick (T/S)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "IGT Dry pick (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_igtdrypick} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "IGT Dry pick (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none',  }}>{data.igtdrypick}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>9</td>
          <td style={{ border: '1px solid black', padding: '4px' ,borderBottom: 'none', borderRight: 'none'}}>Moisture</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Moisture")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_moisture} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Moisture")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' ,borderBottom: 'none', }}>{data.moisture}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>10</td>
          <td style={{ border: '1px solid black', padding: '4px' ,borderBottom: 'none', borderRight: 'none'}}>Brightness -ISO (T/S)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getUnitByProperty(qcpropertylist, "Brightness -ISO (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{data.spec_brightness} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>{getSpecificationByProperty(qcpropertylist, "Brightness -ISO (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none',  }}>{data.brightness}</td>
        </tr>

        {/* <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>11</td>
          <td style={{ border: '1px solid black', padding: '8px' }}>Brightness -ISO (B/S)</td>
          <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{getUnitByProperty(qcpropertylist, "Brightness -ISO (B/S)")}</td>
          <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{data.spec_backbrightness} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}> {getSpecificationByProperty(qcpropertylist, "Brightness -ISO (B/S)")}</td>
          <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{data.back_brightness}</td>
        </tr>

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>12</td>
          <td style={{ border: '1px solid black', padding: '8px' }}>Gloss at 75° (T/S)</td>
          <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{getUnitByProperty(qcpropertylist, "Gloss at 75° (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{data.spec_gloss} </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' }}>{getSpecificationByProperty(qcpropertylist, "Gloss at 75° (T/S)")}</td>
          <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center' }}>{data.gloss}</td>
        </tr> */}

        {data.back_brightness ? (
          <tr>
            <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>11</td>
            <td style={{ border: '1px solid black', padding: '4px' ,borderBottom: 'none', borderRight: 'none'}}>Brightness -ISO (B/S)</td>
            <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' ,borderBottom: 'none', borderRight: 'none'}}>
              {getUnitByProperty(qcpropertylist, "Brightness -ISO (B/S)")}
            </td>
            <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>
              {data.spec_backbrightness}
            </td>
            <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center',borderBottom: 'none', borderRight: 'none' }}>
              {getSpecificationByProperty(qcpropertylist, "Brightness -ISO (B/S)")}
            </td>
            <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' ,borderBottom: 'none',}}>
              {data.back_brightness}
            </td>
          </tr>
        ) : null}

        <tr>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' , borderRight: 'none'}}>
            {data.back_brightness ? "12" : "11"}
          </td>
          <td style={{ border: '1px solid black', padding: '4px' , borderRight: 'none'}}>Gloss at 75° (T/S)</td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' , borderRight: 'none'}}>
            {getUnitByProperty(qcpropertylist, "Gloss at 75° (T/S)")}
          </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', borderRight: 'none' }}>
            {data.spec_gloss}
          </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' , borderRight: 'none'}}>
            {getSpecificationByProperty(qcpropertylist, "Gloss at 75° (T/S)")}
          </td>
          <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center' ,}}>
            {data.gloss}
          </td>
        </tr>


      </tbody>
    </table>

    {/* Footer */}
    <div style={{ marginTop: '80px', marginRight: '80px', textAlign: 'right' }}>
      <p><strong>HOD (QA/QC)</strong></p>
    </div>

    <div style={{ marginTop: '80px', textAlign: 'center' }}>
      <p><>System generated certificate. Signature is not required.</></p>
    </div>
  </div>

));

export default QCReportView;